/**
 * Visual-Data (arkh1ve.com) QR/Barcode Generator Configuration
 * Used in embed mode to generate QR codes and barcodes for engraving designs.
 *
 * Security: VISUAL_DATA_ORIGIN is normalized to scheme+host+port only,
 * so origin comparison with postMessage events is always exact.
 */

export const VISUAL_DATA_ORIGIN = (() => {
  const raw = import.meta.env.VITE_VISUAL_DATA_URL || 'https://www.arkh1ve.com';
  try {
    return new URL(raw).origin;
  } catch {
    return 'https://www.arkh1ve.com';
  }
})();

/**
 * Build the embed URL for the Visual-Data popup.
 * callback_origin tells Visual-Data where to postMessage back to.
 * The receive-side origin + source validation is the true security boundary.
 */
export function getVisualDataEmbedUrl(type: 'qr' | 'barcode'): string {
  const safeType = type === 'barcode' ? 'barcode' : 'qr';
  return `${VISUAL_DATA_ORIGIN}?mode=embed&type=${safeType}&callback_origin=${encodeURIComponent(window.location.origin)}`;
}
